import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import MarketplacePage from "./pages/MarketplacePage";
import OcasionPage from "./pages/OcasionPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import { MessageCircle } from "lucide-react";

function WhatsAppButton() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  const msg = encodeURIComponent("Hola, estoy interesado en vuestros servicios. ¿Me podéis ayudar?");
  return (
    <a
      href={`https://wa.me/34638475651?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/importacion" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/coches-disponibles" element={<MarketplacePage />} />
          <Route path="/ocasion" element={<OcasionPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        theme="dark"
        toastOptions={{
          style: {
            background: '#1A1A1A',
            border: '1px solid rgba(138, 138, 141, 0.2)',
            color: '#E5E5E7'
          }
        }}
      />
    </div>
  );
}

export default App;
